import { render, staticRenderFns } from "./BrowserConfirmationDialog.vue?vue&type=template&id=6b75c974"
import script from "./BrowserConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./BrowserConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports